export default {
  orderNumber: {
    id: 'diagnosis_orderline_recap_order_number',
    defaultMessage: 'Order # {orderId}',
  },
}
